import { render, staticRenderFns } from "./Mandats.vue?vue&type=template&id=4501373e&"
import script from "./Mandats.vue?vue&type=script&lang=js&"
export * from "./Mandats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports